<template>
  <fragment>
    <slot :toggle="toggleModal"></slot>
  </fragment>
</template>

<script>
import { ModalBus } from "@/vue/config/eventBus";

export default {
  name: "modal-slot",
  methods: {
    toggleModal(modalProps) {
      ModalBus.$emit("toggle", modalProps);
    },
  },
};
</script>
